<template>
  <ChartContainer
    :value="current"
    class="filter-control__container"
    :type="type">
  </ChartContainer>
</template>

<script>
  import ChartContainer from "./common/container"

  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer
    },
    data() {
      return {
        current: this.value
      }
    },
    created() {
    },
    methods: {
    }
  }
</script>

<style lang="less">
  .filter-control__container {
    .ry-form__method-select {
      height: 24px;
      margin: 8px 0;
    }

    .filter-control__body {
      margin: 6px;
    }
  }
</style>

